import { z } from 'zod';
import { createModel, QueryMany, partySchema, bankCommonInfoSchema } from '../../common';
import { bankPreferenceSchema } from './bank.preference.model';

export const BankSchema = createModel({
  ...bankCommonInfoSchema.shape,
  /** the preference usage of the bank account such as `primary` or `secondary`.
   *
   * **NOTE** only `ONE` bank account must be set to `primary`.
   */
  preference: bankPreferenceSchema,
  /** the holder of the bank account.
   * This cloud be an organization such as Business or Carrier.
   *
   * Or it cloud be for individuals such as freelancer driver or individuals customers.
   */
  holder: partySchema,
});

/** Bank db model */
export type Bank = z.infer<typeof BankSchema.model>;
export type BankData = z.infer<typeof BankSchema.data>;
export type BankPartial = z.infer<typeof BankSchema.partial>;
export type BankQuery = QueryMany<Bank>;
